// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__7RwqA","content":"Consent_content__Yp7uy","footer":"Consent_footer__3O-Ks"};